import "./v2-question-surface.css";

export default function Wordmark({
  variant = "stacked",
  markSrc = "/glyphs/tgc-124/lantern-v1.png",
  markClassName = "",
}) {
  return (
    <div className={`tgc-v2-wordmark tgc-v2-wordmark--${variant}`} role="img" aria-label="The Gift Conversation">
      <div>The Gift Conversation</div>
      <img
        className={`tgc-v2-wordmark__sparkle ${markClassName}`.trim()}
        src={markSrc}
        alt=""
        aria-hidden="true"
      />
    </div>
  );
}
